import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavMenuService {

  private _siteChange = new Subject()
  siteChangeObservable = this._siteChange.asObservable()

  siteChange(siteId: string) {
    this._siteChange.next(siteId)
  }

  constructor() { 
    console.log(' constructor')
  }
}
